'use client';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'scrimly_plan_v1'; // 'pro' | 'free'

const PlanContext = createContext({
  plan: 'free',
  isPro: false,
  setPlan: (_p) => {},
  togglePlan: () => {},
});

export function PlanProvider({ children }) {
  const [plan, setPlan] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === 'pro' || saved === 'free' ? saved : 'free';
    } catch {
      return 'free';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, plan);
    } catch {}
  }, [plan]);

  const value = useMemo(
    () => ({
      plan,
      isPro: plan === 'pro',
      setPlan,
      togglePlan: () => setPlan((p) => (p === 'pro' ? 'free' : 'pro')),
    }),
    [plan]
  );

  return <PlanContext.Provider value={value}>{children}</PlanContext.Provider>;
}

export function usePlan() {
  return useContext(PlanContext);
}
